"use strict";
/**
 * SiftScienceEnum
 */
exports.__esModule = true;
var SiftScienceEnum;
(function (SiftScienceEnum) {
    SiftScienceEnum["siftScienceTest"] = "sandboxBaconKey";
    SiftScienceEnum["siftScienceProd"] = "prodBaconKey";
})(SiftScienceEnum = exports.SiftScienceEnum || (exports.SiftScienceEnum = {}));
